import { VideoResponse } from "@switcherstudio/api-core-client";
import { CloudflareVideo } from "@switcherstudio/switcher-api-client";

export const mapCloudflareVideoToVideoResponse = (
    response: CloudflareVideo
): VideoResponse => {
    if (!response) return null;

    return {
        Details: {
            Uid: response.uid,
            Duration: response.duration,
            Creator: null,
            LiveInput: response.liveInput,
            ReadyToStream: response.readyToStream,
            Status: response.status as string,
            Thumbnail: response.thumbnail,
            Created: response.created,
            Uploaded: response.uploaded,
            Playback: {
                Dash: response.playback?.dash,
                HLS: response.playback?.hls
            },
            Input: {
                Width: response.input?.width,
                Height: response.input?.height
            }
        }
    };
};
